import { css } from "@emotion/react";

import ListOfLanguages from "context/language/components/ListOfLanguages";
import { useMediaQueries } from "shared";

import GoBack from "./GoBack";
import { SelectedOptionProps } from "./types";

const Language = ({ menuPaperHeight, setContent }: SelectedOptionProps) => {
    const { toMd } = useMediaQueries();

    const LIST_CHOICE_HEIGHT = 48;

    return (
        <div
            css={css({
                maxHeight: menuPaperHeight ?? "unset",
                marginTop: toMd ? `-${LIST_CHOICE_HEIGHT}px` : "0"
            })}
        >
            <GoBack setContent={setContent} />

            <ul
                css={css({
                    overflowY: "auto",
                    maxHeight: menuPaperHeight
                        ? menuPaperHeight - LIST_CHOICE_HEIGHT
                        : "unset"
                })}
            >
                <ListOfLanguages hasApiCall />
            </ul>
        </div>
    );
};

export default Language;
